export default __webpack_public_path__ + "navigation-examples-building-extrusion-v1-960-297a14ebfeacbaaea387063709ee57fc.webp";